import { ApolloProvider } from "@apollo/client";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./css/font-awesome.css";
import "./css/app.css";

import { client } from "./middleware/graphql";
import Layout from "./layouts";

///pages
import Home from "./pages/home";
import ProductPage from "./pages/product";
import CartPage from "./pages/cart";
import Category from "./pages/category";
import CheckoutPage from "./pages/checkout";
import ScrollTop from "./components/utils/ScrollTop";
import WhoWeArePage from "./pages/who-we-are";
import ContactUs from "./pages/client/contact";
import ClientPage from "./pages/client";
import LoginPage from "./pages/login";
import SignUpPage from "./pages/login/sing-up";
import MiCuenta from "./pages/cuenta";
import ForgotPage from "./pages/login/forgot";
import { fauth } from "./middleware/firebase";
import StaticPages from "./pages/static_pages";
import BrandsPage from "./pages/brands";
import PaymentPage from "./pages/payment";

function App() {
  const [user] = useAuthState(fauth);
  return (
    <Router>
      <ScrollTop>
        <ApolloProvider client={client}>
          <Layout>
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              pauseOnHover
            />
            <Routes>
              <Route 
                path="/login" 
                element={user ? <Navigate to="/cuenta" replace /> : <LoginPage />} 
              />
              <Route
                path="/cuenta/:section?/:item_id?"
                element={<MiCuenta />}
              />
              <Route path="/info/:post_name" element={<StaticPages />} />
              <Route path="/sing-up" element={<SignUpPage />} />
              <Route path="/recuperar" element={<ForgotPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/pago/:order_id" element={<PaymentPage />} />
              <Route path="/marca/:brand_name" element={<BrandsPage />} />
              <Route
                path="/productos/:primary?/:secondary?/:tertiary?"
                element={<Category />}
              />
              <Route path="/carrito" element={<CartPage />} />
              <Route path="/como-ser-cliente" element={<ClientPage />} />
              <Route path="/quienes-somos" element={<WhoWeArePage />} />
              <Route path="/contacto" element={<ContactUs />} />
              <Route
                path="/producto/:primary/:secondary/:tertiary/:product_title/:id"
                element={<ProductPage />}
              />
              <Route path="/producto/:id" element={<ProductPage />} />
              <Route path="/" element={<Home />} />
            </Routes>
          </Layout>
        </ApolloProvider>
      </ScrollTop>
    </Router>
  );
}

export default App;
